<mat-accordion [ngStyle]="applyDesign()" class="dialog">

  <mat-expansion-panel hideToggle [expanded]="panelExpanded" disabled>
    <mat-expansion-panel-header>

      <mat-panel-title>

        <div class="question-title-section">

          <span class="title-style">{{ title }}</span>
          <span *ngIf="isFirstQuestionnaire" class="is-mandatory"
            [ngClass]="isConditionFilled ? 'mandatory-valid' : 'mandatory-invalid '"></span>

        </div>

      </mat-panel-title>

      <mat-panel-description>

        <button class="add-edit-button">

          <img *ngIf="medications.length === 0" src="assets/icons/add_button.svg" (click)="openDialog()">
          <img *ngIf="medications.length > 0" src="assets/icons/edit_button.svg" (click)="openDialog()">
        </button>

      </mat-panel-description>

      <button mat-icon-button (click)="panelExpanded = !panelExpanded" class="no-shadow">
        <img src="assets/icons/expand_icon.svg">
      </button>

    </mat-expansion-panel-header>

    <div class="table-style">
      <table style="width: 100%;">
        <tr *ngFor="let medication of medications" class="table-row-even">
          <td>{{medication.medicamento}}</td>
          <td>{{medication.via}}</td>
          <td>{{medication.observacao}}</td>
        </tr>
      </table>
    </div>

  </mat-expansion-panel>
</mat-accordion>